import defaultTheme from './default/theme';

const THEME = process.env.REACT_APP_THEME_BRAND;

const theme = {
  ...{
    ...defaultTheme,
  }[THEME],
};

export default theme;
